import React from 'react';

import PropTypes, { Validator } from 'prop-types';
import { CSSObject } from 'styled-components';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

type TypographyWidthHolderProps = StylableComponent<HTMLParagraphElement> & {
  typographyStyle: CSSObject;
};

/**
 * This component adds a hidden "before" element to text, to verify space is kept when changing font weight.
 */
const TypographyWidthHolder = React.forwardRef<
  HTMLParagraphElement,
  TypographyWidthHolderProps
>(({ style, className, typographyStyle, children, ...props }, ref) => {
  return typeof children === 'string' ? (
    <p
      {...props}
      ref={ref}
      className={className}
      css={[
        {
          margin: 0,
          padding: 0,

          '&:before': {
            content: `"${children}"`,
            display: 'block',
            color: 'transparent',
            visibility: 'hidden',
            overflow: 'hidden',
            height: 0,
            ...typographyStyle,
          },
        },
        style,
      ]}
    >
      {children}
    </p>
  ) : (
    <>{children}</>
  );
});

TypographyWidthHolder.displayName = 'TypographyWidthHolder';

TypographyWidthHolder.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Typography style we want to save space for */
  typographyStyle: PropTypes.object.isRequired as Validator<CSSObject>,

  /** The content of this component */
  children: PropTypes.any,
};

export default TypographyWidthHolder;
